import React,{useState,useEffect } from 'react';
import { useStore } from "react-redux";
import { Button } from '../components/atoms/button';
import { useHistory } from "react-router-dom";
import User from '../User';
import '../resources/css/login/login.css';
import '../resources/RTCC/css/common/common.css'

export const MemberShipCheck = (props) => {

    const history = useHistory();
    const [kaiinkenFlg, setKaiinkenFlg] = useState(false);
    const store = useStore();

    //画面読み込み時に1度だけしか実行させない
    useEffect(() => {
        let state = store.getState().login;
        let memberInfo = null;
        console.log(Object.keys(state).length);
        if(Object.keys(state).length === 0){
            setKaiinkenFlg(true);
            return;
        }
        else{
            memberInfo = state.memberInfo;
        }
        if(memberInfo === null || memberInfo === undefined){
            setKaiinkenFlg(true);
            return;
        }

        // メンバー情報なしの場合
        if(!memberInfo.length){
            setKaiinkenFlg(true);
            return;
        }

        let count = 0;
        for(let i = 0; i < memberInfo.length;i++){
            const memberList = memberInfo[i].memberList;
            if (memberList === null) {
                continue;
            } else if (memberList.data === null) {
                continue;
            }
            const kaiinInfoList = memberList.data.kaiinInfoList;

            if(!kaiinInfoList.length){
                continue;
            }

            for(let j=0; j<kaiinInfoList.length; j++){
                if (kaiinInfoList[j].rtccKanyuKbn && kaiinInfoList[j].rtccKanyuKbn !== "0" 
                        && kaiinInfoList[j].familyFlg === false) {
                    count++;
                }
            }
        }

        if(count == 0){
            setKaiinkenFlg(true)
        }
        else{
            setKaiinkenFlg(false);
        }
    }, []);

    //ログアウト処理
    const logoutClick= () => {
        history.push("/reserve/top");
    };
    
    return (
        <div>
            {kaiinkenFlg ?
            <div className='modalBody'>
                <div className='modalContent'>
                    <div className='modalArea'>
                        <div>
                            <div className='modalText'>このサービスはＲＴＣＣサービスにご登録済のメンバー・オーナーご本人様のみご予約いただけます。</div>
                            <div className='modalText'>※RTTGポイントクラブで会員権ひも付け登録が必要です。（登録方法は<a href='https://www.resorttrust.co.jp/point/linking/' target="_blank" rel="noopener noreferrer">コチラ</a>ご参照ください）</div>
                            <div className='modalBtnArea'>
                            <Button 
                                onClick={logoutClick}
                                buttonText={"TOP画面へ"}
                                className="logoutBtn"
                            />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            :null
            }
        </div>
    )
}